export default "__VITE_ASSET__DiPiOErf__"